export const handleRefreshToken = {
  type: 'function',
  required: true,
}

export const refreshToken = async (url: string) => {
  try {
    const res = await fetch(url, {
      method: 'POST',
      mode: 'same-origin',
      cache: 'no-cache',
      redirect: 'error',
    })
    return res?.json()
  } catch (err) {
    throw new Error('Unauthorized')
  }
}
